module.exports = __webpack_public_path__ + "r-v3/img/pointer_blue.40ea08ba.svg";